import { api } from "../../../../utility/AxiosInceptor";
import React, { useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useEffect } from "react";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
const CreateUser = ({ setShowAddUser, isFromhome, setRefresh }) => {
  const [allRoles, setAllRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  // Get user data from ls
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  const toast = useRef();
  // Validation Schema
  const validationSchema = Yup.object().shape({
    role: Yup.string().required("Required"),
    name: Yup.string().required("Incorrect Name"),
    email: Yup.string().email("Incorrect Email").required("Email is Required"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      role: "",
      name: "",
      email: "",
    },
    onSubmit: async (values) => {
      // Prepare the data to send to the server
      setLoading(true);
      const dataToSend = {
        company: parseLoginRes?.company,
        createdBy: parseLoginRes?._id,
        roleId: formik.values.role,
        name: values.name,
        email: values.email,
      };

      // Send the data to the server using Axios POST request

      api
        .post(`/api/web/user`, dataToSend)
        .then((response) => {
          toast.current.show({
            severity: "success",
            summary: "Create User",
            detail: "successfully Added. Please Check Your Email For Password",
          });
          // navigate("/manage-user");
          if (!isFromhome) {
            setShowAddUser(false);
            setRefresh((prev) => !prev);
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: "Create User",
            detail: error?.response?.data?.msg,
          });
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    const getRoles = async () => {
      try {
        const res = await api.get(
          `/api/web/role/all?serviceProvider=${parseLoginRes?.company}`
        );
        setAllRoles(res?.data?.data || []);
      } catch (error) {
        toast.error(`Error fetching roles : ${error?.response?.data?.msg}`);
      }
    };
    getRoles();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const navigate = useNavigate();
  return (
    <form
      style={{ background: isFromhome && "white" }}
      onSubmit={formik.handleSubmit}
      className="edituserdialogmain"
    >
      <Toast ref={toast} />
      <div className="edituserdialog">
        <div className="edituserform">
          <div className="edituserhead">
            <h1>Add User</h1>
            <p className="para">
              Enter the full name, email, and role for the new user.
            </p>
          </div>
          <div
            className="flex flex-column"
            style={{ gap: "1.2rem", marginTop: "2.4rem" }}
          >
            <div>
              <div className="flex justify-content-between w-full">
                <label htmlFor="name" className="labeltext ">
                  Full Name
                </label>
                {formik.touched.name && formik.errors.name && (
                  <span className="p-error">{formik.errors.name}</span>
                )}
              </div>
              <InputText
                className={`w-full  ${formik.touched.name && formik.errors.name ? "input_texterror" : "input_text"}`}
                id="name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                keyfilter={/^[A-Za-z\s]+$/}
                placeholder="Eleanor Pena"
              />
            </div>
            <div>
              <div className="flex justify-content-between w-full">
                <label htmlFor="email" className="labeltext ">
                  Email
                </label>
                {formik.touched.email && formik.errors.email && (
                  <span className="p-error">{formik.errors.email}</span>
                )}
              </div>
              <InputText
                className={`w-full  ${formik.touched.email && formik.errors.email ? "input_texterror" : "input_text"}`}
                id="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="email"
                keyfilter={/^[a-zA-Z0-9_.@]*$/}
                placeholder="nathan.roberts@example.com"
              />
            </div>

            <div>
              <div className="flex justify-content-between w-full">
                <label htmlFor="email" className="labeltext ">
                  Role
                </label>
                {formik.touched.role && formik.errors.role && (
                  <span className="p-error">{formik.errors.role}</span>
                )}
              </div>
              <Dropdown
                className={`w-full  ${formik.touched.role && formik.errors.role ? "input_texterror" : "input_text"}`}
                id="role"
                options={allRoles}
                value={formik.values.role}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                optionLabel="role"
                optionValue="_id"
                keyfilter={/^[A-Za-z\s]+$/}
              />
            </div>
          </div>
        </div>
        <div
          className="flex  justify-content-end"
          style={{
            height: "5rem",
            width: "63.6rem",
            marginTop: "4.8rem",
            gap: "1.6rem",
          }}
        >
          <Button
            className=" backbtn"
            type="button"
            label="Cancel"
            onClick={() => {
              if (!isFromhome) {
                setShowAddUser(false);
              } else {
                navigate("/manage-user");
              }
            }}
          />
          <Button
            type="submit"
            className="submitbtn"
            label="Submit"
            loading={loading}
          />
        </div>
      </div>
    </form>
  );
};

export default CreateUser;
